'use client';
import { ModuleInstance } from '@/apis/types/cms';
import CheckmarkIcon from '@/assets/icons/checkmark.svg';
import WarningIcon from '@/assets/icons/Warning.svg';
import { useInViewport } from 'ahooks';
import cn from 'clsx';
import { Suspense, useEffect, useState } from 'react';
import BenefitDialog from '../benefitBarWrap/benefitDialog';
import styles from './mental.module.scss';
import { getCmsPageData } from '@/apis/apiCms';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/32413';

interface Props {
  mentalModule: ModuleInstance;
  pageCode: string;
}

export interface MentalObjectType {
  type: string;
}

const MentalClient = ({ mentalModule, pageCode }: Props) => {
  const showType = mentalModule?.dataStyle?.style?.['show-type']?.type;
  const mentalTitles: string[] =
    mentalModule?.dataBatch?.mental?.map((item: any) => item?.mental?.serviceTitle) ?? [];
  const [isOpen, setIsOpen] = useState(false);
  const [inViewport, ratio] = useInViewport(document.getElementById('benefit-bar-wrap'), {
    threshold: 0.01,
  });

  const [shouldShowMental, setShouldShowMental] = useState(false);

  const [currentTab, setCurrentTab] = useState<any>(null);
  const mentalObject: MentalObjectType = {
    type: 'normal', //心智展示类型
  };
  const dataStyle = mentalModule?.dataStyle || null;
  if (dataStyle?.style?.['show-type']?.type) {
    mentalObject.type = dataStyle?.style?.['show-type']?.type;
  }
  const { type } = mentalObject || {};

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const pageData = await getCmsPageData(pageCode);
        const floors = pageData?.data?.floors || [];
        const moduleData = floors
          .flatMap((floor: any) => floor.moduleInstances || [])
          .find((instance: any) => instance.moduleCode === 'uk-miniHome');
        const tabList = moduleData?.dataBatch?.tabList ?? [];
        const foundTab = tabList.find(
          (tab: any) => pageCode === tab?.jumpLink?.jumpValue?.pageCodeInfo?.pageCode,
        );
        setCurrentTab(foundTab);
      } catch (error) {
        console.error('Failed to fetch page data:', error);
      }
    };

    fetchPageData();
  }, [pageCode]);

  useEffect(() => {
    setTimeout(() => {
      setShouldShowMental(true);
    }, 500);
  });

  const isNormal = showType === 'normal';
  const mindList = mentalModule?.dataBatch?.mental?.map((m: any) => m?.mental);
  const dialogTitle = mentalModule?.dataStyle?.style?.['show-type']?.title;

  const handleClose = () => {
    setIsOpen(false);
  };

  const openDialog = () => {
    setIsOpen(true);
  };

  // 当找不到元素时 inViewport 会默认是是undefined，所以这里不能用!inViewport来判断，要用inViewport === false判断，否则mental组件会闪烁一下
  return (
    inViewport === false &&
    shouldShowMental &&
    mentalTitles?.length > 0 && (
      <>
        <div className={cn(styles.mental, { [styles.warning]: !isNormal })} onClick={openDialog}>
          {mentalTitles.map((title) => (
            <div
              key={title}
              className={styles.titleBox}
              exptag={'exp|' + EXPOSURE_RECORD.Home_Platform_Mind_Expo}
              data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
              data-exptag-json-param={JSON.stringify({
                title,
                styleType: type === 'normal' ? '2' : '3',
                Mini_Hp_Name: currentTab?.pageName || 'home',
              })}
              onClick={() => {
                sendClickTrack.Home_Platform_Mind({
                  // @ts-ignore
                  title,
                  // @ts-ignore
                  styleType: type === 'normal' ? '2' : '3',
                  Mini_Hp_Name: currentTab?.pageName || 'home',
                });
              }}
            >
              {isNormal ? <CheckmarkIcon /> : <WarningIcon />}
              <span className={styles.title}>{title}</span>
            </div>
          ))}
        </div>
        {isOpen && (
          <Suspense fallback={null}>
            <BenefitDialog
              open={isOpen}
              title={dialogTitle}
              mindList={mindList}
              closeFn={handleClose}
            />
          </Suspense>
        )}
      </>
    )
  );
};
export default MentalClient;
